export default __webpack_public_path__ + "static/media/Photo 2 - MR - Façade vitrée.98349ebd.png";